import request from '@/utils/request'

let DdeliveryApi = {

  /*发货单列表*/
  list(data) {
    return request._post('/shop/plus.ddelivery.Index/index', data);
},
  /*发货单列表-打印单*/
  listp(data) {
    return request._post('/shop/plus.ddelivery.Index/indexp', data);
},
getListph(data) {
  return request._post('/shop/plus.ddelivery.Index/getListph', data);
},
/*添加发货单*/
add(data) {
    return request._post('/shop/plus.ddelivery.Index/add', data);
},
/*修改发货单*/
edit(data) {
    return request._post('/shop/plus.ddelivery.Index/edit', data);
},
/*删除发货单*/
del(data) {
    return request._post('/shop/plus.ddelivery.Index/del', data);
},
/*发货单详情*/
detail(data) {
  return request._post('/shop/plus.ddelivery.Index/detail', data);
},
getIndex(data) {
    return request._post('/shop/plus.ddelivery.Index/getIndex', data);
  },
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ddelivery.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ddelivery.Setting/getSetting', data, errorback);
    },

    genDdelivery(data) {
        return request._post('/shop/plus.ddelivery.Index/genDdelivery', data);
    },

}
export default DdeliveryApi;



// WEBPACK FOOTER //
// ./src/api/ddelivery.js